import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  partners: [],
  routingRules: [],
  loading: false,
  error: null,
  selectedPartnerId: null,
  selectedRoutingRuleId: null,
};

const responsePartnerSlice = createSlice({
  name: 'responsePartnerList',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = Boolean(action.payload);
    },
    setError: (state, action) => {
      state.error = action.payload || null;
    },
    setPartners: (state, action) => {
      state.partners = Array.isArray(action.payload) ? action.payload : [];
    },
    upsertPartner: (state, action) => {
      const partner = action.payload;
      if (!partner || !partner.id) return;
      const idx = state.partners.findIndex((p) => p.id === partner.id);
      if (idx === -1) {
        state.partners.push(partner);
      } else {
        state.partners[idx] = { ...state.partners[idx], ...partner };
      }
    },
    removePartner: (state, action) => {
      const id = action.payload;
      state.partners = state.partners.filter((p) => p.id !== id);
      state.routingRules = state.routingRules.filter((r) => r.responsePartnerId !== id);
      if (state.selectedPartnerId === id) state.selectedPartnerId = null;
    },
    setSelectedPartnerId: (state, action) => {
      state.selectedPartnerId = action.payload ?? null;
    },
    setRoutingRules: (state, action) => {
      state.routingRules = Array.isArray(action.payload) ? action.payload : [];
    },
    upsertRoutingRule: (state, action) => {
      const rule = action.payload;
      if (!rule || !rule.id) return;
      const idx = state.routingRules.findIndex((r) => r.id === rule.id);
      if (idx === -1) {
        state.routingRules.push(rule);
      } else {
        state.routingRules[idx] = { ...state.routingRules[idx], ...rule };
      }
    },
    removeRoutingRule: (state, action) => {
      const id = action.payload;
      state.routingRules = state.routingRules.filter((r) => r.id !== id);
      if (state.selectedRoutingRuleId === id) state.selectedRoutingRuleId = null;
    },
    setSelectedRoutingRuleId: (state, action) => {
      state.selectedRoutingRuleId = action.payload ?? null;
    },
    resetResponsePartnerState: () => initialState,
  },
});

export const {
  setLoading,
  setError,
  setPartners,
  upsertPartner,
  removePartner,
  setSelectedPartnerId,
  setRoutingRules,
  upsertRoutingRule,
  removeRoutingRule,
  setSelectedRoutingRuleId,
  resetResponsePartnerState,
} = responsePartnerSlice.actions;

export default responsePartnerSlice.reducer;
